export default __webpack_public_path__ + "static/media/cta_wide.ab025081.svg";